import { useState } from "react";

export const useMultiSelect = (defaultValues = []) => {
  const [values, setValues] = useState<string[]>(defaultValues);

  return {
    values,
    setValues,
  };
};
